import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }

import { useConfirmStore } from "@/store/confirm";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmPopup',
  setup(__props) {

const $confirm = useConfirmStore();

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref($confirm).opened.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref($confirm).opened.value) = $event)),
    persistent: "",
    "max-width": "400px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pb-2" }, {
        default: _withCtx(() => [
          (_unref($confirm).state.color)
            ? (_openBlock(), _createBlock(_component_v_toolbar, {
                key: 0,
                dense: "",
                color: _unref($confirm).state.color
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($confirm).state.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["color"]))
            : (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($confirm).state.title), 1)
                ]),
                _: 1
              })),
          (_unref($confirm).state.content)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 2,
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($confirm).state.content), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_actions, {
            class: _normalizeClass(_unref($confirm).state.content ? 'mt-4 pl-4' : 'mt-8 pl-4')
          }, {
            default: _withCtx(() => [
              (!Array.isArray(_unref($confirm).state.confirmText))
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: _unref($confirm).state.color,
                    class: "mr-4",
                    variant: "tonal",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref($confirm).confirm()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($confirm).state.confirmText), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref($confirm).state.confirmText, (text, i) => {
                      return (_openBlock(), _createBlock(_component_v_btn, {
                        key: i,
                        color: _unref($confirm).state.color,
                        class: "mr-4",
                        variant: i === 0 ? 'tonal' : 'outlined',
                        onClick: ($event: any) => (_unref($confirm).confirm(i))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["color", "variant", "onClick"]))
                    }), 128))
                  ])),
              _createVNode(_component_v_btn, {
                variant: "outlined",
                onClick: _unref($confirm).cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($confirm).state.cancelText), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})